/* ==========================================================================
   Daily Dons theme — interaction layer.
   Vanilla JS, no dependencies. Handles: carousel, pack/size variant
   selection, AJAX cart (add/update/remove + drawer), accordions, mobile nav.
   ========================================================================== */

(function () {
  'use strict';

  /* ---------- helpers ---------- */

  function money(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
    }).format(cents / 100);
  }

  function on(root, selector, event, handler) {
    root.addEventListener(event, function (e) {
      var t = e.target.closest(selector);
      if (t && root.contains(t)) handler(e, t);
    });
  }

  /* ---------- mobile nav ---------- */

  var menuBtn = document.querySelector('[data-mobile-menu-btn]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (menuBtn && mobileNav) {
    var setMenu = function (open) {
      menuBtn.setAttribute('aria-expanded', String(open));
      menuBtn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      mobileNav.hidden = !open;
    };
    menuBtn.addEventListener('click', function () {
      setMenu(mobileNav.hidden);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !mobileNav.hidden) setMenu(false);
    });
    document.addEventListener('click', function (e) {
      var wrap = menuBtn.closest('[data-mobile-menu-wrap]');
      if (!mobileNav.hidden && wrap && !wrap.contains(e.target)) setMenu(false);
    });
    mobileNav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { setMenu(false); });
    });
  }

  /* ---------- carousel ---------- */

  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-slide]'));
    var thumbs = Array.prototype.slice.call(carousel.querySelectorAll('[data-carousel-thumb]'));
    if (!slides.length) return;
    var index = 0;

    function show(i) {
      index = ((i % slides.length) + slides.length) % slides.length;
      slides.forEach(function (s, j) { s.classList.toggle('is-active', j === index); });
      thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === index ? 'true' : 'false'); });
      // preload adjacent images
      [index - 1, index + 1].forEach(function (j) {
        var n = ((j % slides.length) + slides.length) % slides.length;
        var img = slides[n] && slides[n].querySelector('img');
        if (img && img.loading === 'lazy') img.loading = 'eager';
      });
    }

    var prev = carousel.querySelector('[data-carousel-prev]');
    var next = carousel.querySelector('[data-carousel-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
    thumbs.forEach(function (t, j) {
      t.addEventListener('click', function () { show(j); });
    });
    carousel.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(index - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(index + 1); }
    });
  });

  /* ---------- accordions (product details + FAQ) ---------- */

  document.querySelectorAll('[data-accordion-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      var open = btn.getAttribute('aria-expanded') === 'true';
      // close siblings within the same accordion group
      var group = btn.closest('.dd-accordion, .dd-faq');
      if (group && !open) {
        group.querySelectorAll('[data-accordion-btn]').forEach(function (other) {
          if (other !== btn) {
            other.setAttribute('aria-expanded', 'false');
            var p = document.getElementById(other.getAttribute('aria-controls'));
            if (p) p.classList.remove('is-open');
          }
        });
      }
      btn.setAttribute('aria-expanded', String(!open));
      if (panel) panel.classList.toggle('is-open', !open);
    });
  });

  /* ---------- cart drawer ---------- */

  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');

  function openCart() {
    if (!drawer) return;
    drawer.hidden = false;
    overlay.hidden = false;
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
    });
    document.body.style.overflow = 'hidden';
    var closeBtn = drawer.querySelector('[data-cart-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () {
      drawer.hidden = true;
      overlay.hidden = true;
    }, 300);
  }

  document.querySelectorAll('[data-cart-open]').forEach(function (b) {
    b.addEventListener('click', openCart);
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (b) {
    b.addEventListener('click', closeCart);
  });
  if (overlay) overlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeCart();
  });
  document.querySelectorAll('[data-cart-close-link]').forEach(function (a) {
    a.addEventListener('click', closeCart);
  });

  function refreshCartUI(cart) {
    // count badges
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
    });
    // subtotal
    var subtotal = document.querySelector('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = money(cart.total_price);
    // foot visibility
    var foot = document.querySelector('[data-cart-foot]');
    if (foot) foot.hidden = cart.item_count === 0;
    // re-render items
    var body = document.querySelector('[data-cart-body]');
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML =
        '<div class="dd-cart__empty">' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg>' +
        '<p>Your cart is empty.</p>' +
        '<a href="#buy" class="dd-btn" data-cart-close-link>Shop The Daily Shorts</a>' +
        '</div>';
      body.querySelector('[data-cart-close-link]').addEventListener('click', closeCart);
      return;
    }
    var html = '<ul data-cart-items>';
    cart.items.forEach(function (item) {
      html +=
        '<li class="dd-cart__item" data-cart-item data-line-key="' + item.key + '">' +
        (item.image
          ? '<img src="' + item.image.replace(/(\.[^.]*)$/, '_144x144$1') + '" alt="" width="144" height="144">'
          : '') +
        '<div class="dd-cart__item-body">' +
        '<p class="dd-cart__item-title">' + item.product_title + '</p>' +
        '<p class="dd-cart__item-variant">' + (item.variant_title || '') + '</p>' +
        '<div class="dd-cart__qty">' +
        '<button type="button" aria-label="Decrease quantity" data-qty-minus><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/></svg></button>' +
        '<span data-qty>' + item.quantity + '</span>' +
        '<button type="button" aria-label="Increase quantity" data-qty-plus><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="M12 5v14"/></svg></button>' +
        '</div></div>' +
        '<div class="dd-cart__item-right">' +
        '<p class="dd-cart__item-price">' + money(item.final_line_price) + '</p>' +
        '<button type="button" class="dd-cart__remove" data-remove>Remove</button>' +
        '</div></li>';
    });
    html += '</ul>';
    body.innerHTML = html;
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    }).then(function (r) { return r.json(); }).then(refreshCartUI);
  }

  if (drawer) {
    on(drawer, '[data-qty-minus]', 'click', function (e, btn) {
      var item = btn.closest('[data-cart-item]');
      var qty = parseInt(item.querySelector('[data-qty]').textContent, 10);
      changeLine(item.getAttribute('data-line-key'), Math.max(0, qty - 1));
    });
    on(drawer, '[data-qty-plus]', 'click', function (e, btn) {
      var item = btn.closest('[data-cart-item]');
      var qty = parseInt(item.querySelector('[data-qty]').textContent, 10);
      changeLine(item.getAttribute('data-line-key'), qty + 1);
    });
    on(drawer, '[data-remove]', 'click', function (e, btn) {
      var item = btn.closest('[data-cart-item]');
      changeLine(item.getAttribute('data-line-key'), 0);
    });
  }

  /* ---------- buy panel: pack/size → variant, add to cart ---------- */

  var panel = document.querySelector('[data-buy-panel]');
  if (panel) {
    var variantMapEl = document.querySelector('[data-variant-map]');
    var variants = [];
    try {
      variants = JSON.parse(variantMapEl.textContent);
    } catch (e) {
      variants = [];
    }

    var state = { pack: '3 Pairs', size: 'L' };

    panel.querySelectorAll('[data-pack]').forEach(function (btn) {
      if (btn.getAttribute('aria-checked') === 'true') state.pack = btn.getAttribute('data-pack');
      btn.addEventListener('click', function () {
        state.pack = btn.getAttribute('data-pack');
        panel.querySelectorAll('[data-pack]').forEach(function (b) {
          b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
        });
      });
    });

    panel.querySelectorAll('[data-size]').forEach(function (btn) {
      if (btn.getAttribute('aria-pressed') === 'true') state.size = btn.getAttribute('data-size');
      btn.addEventListener('click', function () {
        state.size = btn.getAttribute('data-size');
        panel.querySelectorAll('[data-size]').forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
      });
    });

   function findVariant() {
  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  return variants.find(function (v) {
    if (!v || !v.options || !v.pack) return false;

    var packMatches =
      normalize(v.pack) === normalize(state.pack);

    var sizeMatches = v.options.some(function (option) {
      return normalize(option) === normalize(state.size);
    });

    return packMatches && sizeMatches;
  });
}

    var atc = panel.querySelector('[data-add-to-cart]');
    var atcLabel = panel.querySelector('[data-atc-label]');
    var atcError = panel.querySelector('[data-atc-error]');

    if (atc) {
      atc.addEventListener('click', function () {
        atcError.hidden = true;
        var variant = findVariant();
        if (!variant) {
          atcError.textContent = 'This combination is unavailable. Please pick another size.';
          atcError.hidden = false;
          return;
        }
        if (!variant.available) {
          atcError.textContent = 'This size is currently sold out.';
          atcError.hidden = false;
          return;
        }
        atc.disabled = true;
        atcLabel.textContent = 'Adding…';
        fetch('/cart/add.js', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({
    items: [{
      id: variant.id,
      quantity: 1
    }]
  }),
})
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return fetchCart();
          })
          .then(function (cart) {
            refreshCartUI(cart);
            openCart();
          })
          .catch(function () {
            atcError.textContent = 'Could not add to cart. Please try again.';
            atcError.hidden = false;
          })
          .finally(function () {
            atc.disabled = false;
            atcLabel.textContent = 'Add to Cart';
          });
      });
    }
  }
})();
